// CÓDIGO 100% COMPLETO
import React from 'react';

const GlassButton = ({ children, className = '', onClick, type = 'button', disabled = false, title = '', variant = 'default' }) => {
    const baseClasses = "font-semibold py-2 px-4 rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-500/50 disabled:opacity-50 disabled:cursor-not-allowed transform active:scale-95 transition-all duration-200 ease-in-out flex items-center justify-center gap-2";

    const styles = {
        default: "bg-gray-200 text-gray-800 shadow-md hover:bg-gray-300 dark:bg-white/20 dark:text-white dark:hover:bg-white/30",
        minimal: "bg-transparent text-gray-600 hover:bg-black/10 dark:text-gray-300 dark:hover:bg-white/10 dark:hover:text-white"
    };

    return (
        <button
            type={type}
            disabled={disabled}
            onClick={onClick}
            title={title}
            className={`${baseClasses} ${styles[variant] || styles.default} ${className}`}
        >
            {children}
        </button>
    );
};

export default GlassButton;